
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderModel } from './Entities.GormCrm.Order';
import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { QuestionModel } from './Entities.GormCrm.Question';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireQuestionReplyModel extends Model<QuestionnaireQuestionReplyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'questionId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'createdById', type: 'string' },
		{ name: 'replyData', type: 'string' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'orderLine', type: 'OrderLineModel', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'question', type: 'QuestionModel', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public questionId?: string;
	public companyId?: string;
	public orderId?: string;
	public orderLineId?: string;
	public taskflowId?: string;
	public created?: Date;
	public createdById?: string;
	public replyData: string;
	public company?: CompanyModel;
	public order?: OrderModel;
	public orderLine?: OrderLineModel;
	public question?: QuestionModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.questionId = undefined;
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.created = undefined;
		this.createdById = undefined;
		this.replyData = '';
		this.company = undefined;
		this.order = undefined;
		this.orderLine = undefined;
		this.question = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return QuestionnaireQuestionReplyModel.classProperties;
	}
}

